import { ChangeEventHandler, VFC } from "react";
import { TextDataField } from "src/types/data-field.types";
import { NodeData } from "src/types/node.types";
import { FormField } from "../form-field";
import { Input } from "./input";

export interface TextFieldProps {
  field: TextDataField;
  data: NodeData;
  onChange: (data: NodeData) => void;
}

export const TextField: VFC<TextFieldProps> = (props) => {
  const key = props.field.key;
  const onChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const value = e.target.value;
    props.onChange({ ...props.data, [key]: value });
  };

  const value = props.data[key] as string;

  return (
    <FormField.Field>
      <FormField.Label>{props.field.label}</FormField.Label>
      <FormField.Input>
        <Input value={value} onChange={onChange} format={props.field.format} />
      </FormField.Input>
    </FormField.Field>
  );
};
